module.exports = __webpack_public_path__ + "img/1.596dfeac.png";